import React from "react";
import StudentCalendar from "../../../scheduling/student_calendar/StudentCalendar";
import "./StudentCalendarTab.css";

export default function StudentCalendarTab({ student, permissions }) {
  const readOnly = permissions ? !permissions.editCalendar : false;
  return (
    <div className="student-calendar-tab">
      <StudentCalendar lockedStudent={student} embedded readOnly={readOnly} />
    </div>
  );
}
